import React from 'react';
import DashEstablishmentContainer from 'modules/dashboard/_common/DashEstablishmentContainer';
import RestaurantStatisticsPage from 'modules/restaurant/statistics/RestaurantStatisticsPage';

export default function DashRestaurantStatistics() {
    return (
        <DashEstablishmentContainer title='Estatísticas'>
            <RestaurantStatisticsPage />
        </DashEstablishmentContainer>
    );
}
